import React from "react";
import styled from "styled-components";

import ProjectState from "../States/ProjectState";
import Project from "./project";
import { motion } from "framer-motion";

const ProjectsList = () => {
  const project = ProjectState();
  return (
    <StyledProjectList
      initial={{ opacity: 0 }}
      animate={{
        opacity: 1,
        transition: {
          delay: 2,
        },
      }}
    >
      {project.map((p) => {
        return (
          <Project
            tech={p.technology}
            glink={p.glink}
            link={p.link}
            name={p.name}
            image={p.image}
            desc={p.desc}
            date={p.date}
          />
        );
      })}
    </StyledProjectList>
  );
};

const StyledProjectList = styled(motion.div)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
`;

export default ProjectsList;
